import $ from 'jquery';
import { clearDeferredAnimations, getDurationFromElement } from '../../util/animate-css.js';
// import mpro from './mpro.init';

// ===================================
// Loading helpers
// ===================================

/**
 * @param {JQuery<Partial<HTMLElement>>} $btn
 */
mpro.addButtonLoading = function($btn) {
	// !Important: Just disable the button visually, but not the submit functionality (it's value must be submitted)
	$btn.addClass('btn-loading disabled pointer-none').on('click.addButtonLoading', false);
};

/**
 * @param {JQuery<Partial<HTMLElement>>} $btn
 */
mpro.removeButtonLoading = function($btn) {
	$btn.removeClass('btn-loading disabled pointer-none').off('click.addButtonLoading');
};

/**
 * @param {JQuery<Partial<HTMLElement>>} $btn
 */
mpro.addButtonDisabled = function($btn) {
	$btn.addClass('disabled').prop('disabled', true);
};

/**
 * @param {JQuery<Partial<HTMLElement>>} $btn
 */
mpro.removeButtonDisabled = function($btn) {
	$btn.removeClass('disabled').prop('disabled', false);
};

/**
 * @param {JQuery<Partial<HTMLElement>>} $container
 */
mpro.addLoading = function($container) {
	const cData = $container.data();
	if (cData.$loader) {
		cData.$loader.remove();
	}
	const $loader = $('<div class="loader"><div class="loader-wrapper"><div class="loader-animation"></div></div></div>');
	cData.$loader = $loader;
	$container.append($loader);
	mpro.reflow($loader);
	$loader.addClass('visible').children().addClass('visible');
};

/**
 * @param {JQuery<Partial<HTMLElement>>} $container
 */
mpro.removeLoading = function($container) {
	const cData = $container.data();
	const { $loader } = cData;
	if ($loader) {
		cData.$loader = null;
		$loader.removeClass('visible').children().removeClass('visible').end().animate({ fakeProp: 1 }, 300, () => {
			$loader.remove();
		});
	}
};

/**
 * Attach a load animation to a section of the DOM
 *
 * @param {JQuery<Partial<HTMLElement>> | Partial<HTMLElement>} container
 * @param {string | string[] =} modifierClasses
 * @param {{ delay?: number; } =} options
 */
mpro.addContentLoader = (container, modifierClasses, options = {}) => {

	/** @type {JQuery} */
	// @ts-ignore
	let $container = (container instanceof $) ? container : $(container);

	if ($container.length === 0) {
		return;
	}

	// Move the loading animation to the parent element
	if ($container.is('input,textarea,select')) {
		$container = $container.parent();
	}

	if ((modifierClasses === 'auto') && ($container.is('[data-mp-overlay-body]') === false)) {
		const height = $container.height();
		const loaderHeight = (height > 300)
			? undefined
			: (
				(height > 100)
					? 'md'
					: (
						(height > 32)
							? 'sm'
							: 'xs'
					)
			);
		modifierClasses = loaderHeight ?? null;
	}

	const data = $container.data();
	const modifiers = [modifierClasses || []].flat().map(v => ('loading--' + v));
	const classes = ['loading', ...modifiers].join(' ');
	const delay = ('delay' in options) ? Number(options.delay) : 0 /* 366 */;
	const timer = data._delayedLoadingTimer;

	if (timer) {
		window.clearTimeout(timer);
		data._delayedLoadingTimer = null;
	}

	const exec = () => {
		data._loadingClasses = classes;

		// Check if the container is a table row
		const container = $container[0];

		// Container add on a TR, we need to add an extra col inside the table colgroup element (but only if it is present).
		// This is done in order tu circumvent table layout issues mentioned on this issue: SHM-I11726
		if (container.tagName === 'TR') {
			const table = container.closest('table');
			if (table) {
				const colgroup = table.querySelector('colgroup');
				if (colgroup) {
					const col = document.createElement('col');
					col.style.width = '0.001%';
					colgroup.append(col);
					data._loadingCol = col;
				}
			}
		}

		$container.addClass(classes);
		mpro.reflow($container);
	};

	// Show later
	if (delay > 0) {
		data._delayedLoadingTimer = window.setTimeout(exec, delay);
	}
	// Show now
	else {
		exec();
	}
};

/**
 * Detach a previously added load animation from a section of the DOM
 *
 * @param {JQuery<Partial<HTMLElement>> | Partial<HTMLElement>} container
 * @param {{ animated?: boolean; } =} options
 */
mpro.removeContentLoader = (container, options = {}) => {

	/** @type {JQuery} */
	// @ts-ignore
	let $container = (container instanceof $) ? container : $(container);

	if ($container.length === 0) {
		return;
	}

	// Move the loading animation to the parent element
	if ($container.is('input,textarea,select')) {
		$container = $container.parent();
	}

	// Clear any deferred animations
	clearDeferredAnimations($container);

	const data = $container.data();
	let classes = data._loadingClasses || [...$container[0].classList].find(v => v.startsWith('loading')) || null;
	const timer = data._delayedLoadingTimer;

	if (timer) {
		window.clearTimeout(timer);
		data._delayedLoadingTimer = null;
	}

	const { animated } = options;

	if (animated) {
		classes = [classes || '', 'loading--removing'].join(' ');
		// mpro.reflow($container);
		$container.addClass('loading--removing');
		data._delayedLoadingTimer = window.setTimeout(() => {
			classes && $container.removeClass(classes);
			data._loadingClasses = null;
			$container.removeAttr('data-loading-text');
			if (data._loadingCol) {
				data._loadingCol.remove();
				data._loadingCol = null;
			}
		}, getDurationFromElement('transition', $container[0]) || 150);
	}
	else {
		classes && $container.removeClass(classes);
		data._loadingClasses = null;
		$container.removeAttr('data-loading-text');
	}
};

/**
 * Return the default loading placeholder text
 */
mpro.getLoadingPlaceholder = () => {
	return '<div class="loading loading--sm" style="min-width: 160px; margin: 0.5rem;"></div>';
};

export default mpro;
